import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { validateSession } from '../../API/APICalls';
import Loading from '../../Components/Loading';
import SnackbarShow from '../../Components/SnackbarShow';
import UserCreateForm from '../../Components/Mailbox/UserCreateForm';


const MailboxCreatePage = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [domainDetails, setDomainDetails] = useState([]);
    const [windowClose, setWindowClose] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState({ open: false, message: '', severity: '' });


    const sessionValidation = async (id) => {
        try {
            setLoading(true);
            const response = await validateSession(id);
            if (response.status === 200) {
                setDomainDetails(response.data);
                const expiryTime = new Date(Date.now() + 7 * 60 * 1000).getTime();
                window.sessionStorage.setItem('expiry_time', expiryTime);
            } else {
                setSnackbarMessage({ open: true, message: response.data.message, severity: 'error' });
                setWindowClose(true);
            }
        } catch (error) {
            setSnackbarMessage({ open: true, message: 'Something went wrong. Please try again later.', severity: 'error' });
            setWindowClose(true);
            console.error('User information getting failed error: ', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => { sessionValidation(id) }, [id]);
    if (windowClose) {
        setTimeout(() => { window.close(); }, 6000);
    }

    let snackbarMessageComp = (snackbarMessage.open) ? (<SnackbarShow data={snackbarMessage} setSnackbarMessage={setSnackbarMessage} />) : null;
    let userCreateComp = (domainDetails === undefined || domainDetails === null ) ? (
        <h1>User details not found or session is not valid.</h1>
    ) : (
        <UserCreateForm id={id} domainDetails={domainDetails} />
    );

    if (loading) {
        return <Loading />
    }

    return (
        <>
            {snackbarMessageComp}
            {userCreateComp}
        </>
    )
}

export default MailboxCreatePage;
